import { render, staticRenderFns } from "./VocuherListItem.vue?vue&type=template&id=2f8b4cb0&"
import script from "./VocuherListItem.vue?vue&type=script&lang=js&"
export * from "./VocuherListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports